import React from 'react';

export const ActionBarContext = React.createContext<'primary' | 'secondary'>(
  'primary'
);
ActionBarContext.displayName = 'ActionBarContext';

export const SecondaryActionBarContext = React.createContext<{
  setTopActionBarRef: (node: HTMLElement | null) => void;
}>({
  setTopActionBarRef: () => null,
});
SecondaryActionBarContext.displayName = 'SecondaryActionBarContext';

/**
 * Holds a boolean that tells us if any dialog is shown by our ActionBar controls.
 */
export const ActionBarDialogContext = React.createContext<boolean>(false);
